/* eslint-disable react/react-in-jsx-scope */
import './App.scss';
import Header from './header/header';
import CurencyList from './curency-list/curency-list';

function App() {
  return (
    <>
      <Header />
      <CurencyList />
    </>
  );
}
export default App;
